// Dependencies
require("grid");
require("section/generic");
require("element/rich-text");



/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/paragraphe/index.js
 ** module id = 115
 ** module chunks = 0 1
 **/